import logConversionEventHandleRemoveCartAction from 'modules/cart/redux/actions/toggle-add-remove/actions/handle-remove/actions/log-conversion-event'
import removeItemCartAction from 'modules/cart/redux/actions/remove-item'

const ANALYTICS_EVENT = {
  REMOVE_STORE_CREDIT: 'REMOVE_STORE_CREDIT',
  REMOVE_FROM_CART: 'REMOVE_FROM_CART',
  REMOVE_FULL_SIZE_CONVERSION_FROM_CART: 'REMOVE_FULL_SIZE_CONVERSION_FROM_CART'
}

/**
 * @param props {handleRemoveProductCartActionProps}
 * @returns {(function(*, *): Promise<undefined|{wasRemoved: *, wasAdded}>)|*}
 */
export default function handleRemoveProductCartAction (props) {
  return async (dispatch) => {
    const {
      variantId,
      logEvent,
      isGiftCard,
      productVariant,
      shouldShowFullSizeConversion
    } = props

    if (shouldShowFullSizeConversion) {
      logEvent(ANALYTICS_EVENT.REMOVE_FULL_SIZE_CONVERSION_FROM_CART)
    } else if (isGiftCard) {
      logEvent(ANALYTICS_EVENT.REMOVE_STORE_CREDIT)
    } else {
      logEvent(ANALYTICS_EVENT.REMOVE_FROM_CART)
    }

    await dispatch(
      removeItemCartAction({
        variantId,
        shouldRemoveLocally: true
      })
    )

    dispatch(
      logConversionEventHandleRemoveCartAction({
        productVariant,
        variantId
      })
    )
  }
}
